"use strict";

define('language/support/supplemental.bootstrap.locales',['require','exports','module'],function (require, exports, module) {
  module.exports = {
    "en-sg": {
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      daysMin: ["S", "M", "T", "W", "T", "F", "S"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      today: "Today",
      clear: "Clear",
      format: "d/mm/yyyy"
    },
    "zh-sg": {
      days: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期"],
      daysShort: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
      daysMin: ["日", "一", "二", "三", "四", "五", "六"],
      months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
      monthsShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      today: "今天",
      format: "yyyy年mm月dd日"
    }
  };
});

